function ComplaintsReducer(state = { complaintsMainGroups: [], complaintsSubGroups: [], complaintsTargetList: [], complaintList:[] }, action) {
    switch (action.type) {
        case "GET_COMPLAINT_MAINGROUP":
            return {
                ...state,
                complaintsMainGroups: action.data
            }
        case "GET_COMPLAINT_SUBGROUP":
            return {
                ...state,
                complaintsSubGroups: action.data
            }
        case "GET_COMPLAINT_TARGETS":
            return {
                ...state,
                complaintsTargetList: action.data
            }
        case "GET_COMPLAINT_LIST":
            return {
                ...state,
                complaintList: action.data
            }
        default:
            return state;
    }
}
export default ComplaintsReducer;